import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SelectCreate from '../../../components/selectCreateComponent/SelectCreate';
import FormDatosCliente from './FormDatosCliente';
import CardItem from '../../../components/selectCreateComponent/CardItem';
import { Icon } from '@iconify/react';
import { firestore } from '../../../../contexts/FirebaseContext';
import useAuth from '../../../../hooks/useAuth';
import { statusFacturar } from '../../../../constants/facturarEnvio';
import { LoadingButton } from '@mui/lab';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

export default function DialogFacturar({ envioDetalle }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Box>
      <Button
        disabled={envioDetalle?.status_factura === 'PENDIENTE'}
        variant="contained"
        color="info"
        onClick={() => setOpenDialog(true)}
      >
        Pedir factura
      </Button>
      <MyDialog open={openDialog} onClose={setOpenDialog} envioDetalle={envioDetalle} />
    </Box>
  );
}

function MyDialog({ open, onClose, envioDetalle }) {
  const [fiscalDirections, setFiscalDirections] = useState([]);
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const [loadingButton, setLoadingButton] = useState(false);
  const { itemsSelected } = useSelector((state) => state.selectCreate);
  const direcFisc = itemsSelected.find((item) => item.selectCreateId === 'facturar');

  console.log('esta esla', direcFisc);

  console.log(fiscalDirections);

  useEffect(() => {
    async function getPaqueterias() {
      await firestore
        .collection('fiscal_direction')
        .where('relatedUser', '==', user.id)
        // .orderBy('created_at', 'desc')
        // .limit(200)
        .onSnapshot((snapshot) => {
          const fiscalDirecs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          console.log('esta es', fiscalDirecs);
          setFiscalDirections(fiscalDirecs);
        });
    }
    getPaqueterias();
    // dispatch(getProducts());
  }, [user]);

  const handleClose = () => {
    onClose(false);
  };

  const pedirFactura = async () => {
    setLoadingButton(true);
    console.log('factura');
    const obj = {
      envioDetalle,
      direcFisc,
      createdAt: new Date(),
      updatedAt: new Date(),
      status: statusFacturar.pendiente,
      userId: user.id
    };

    try {
      await firestore.collection('solicitar_facturas').add(obj);

      await firestore
        .collection('cotizaciones')
        .doc(envioDetalle.id)
        .update({ status_factura: statusFacturar.pendiente });

      enqueueSnackbar('La solicitud de factura se ha enviado correctamente', { variant: 'success' });
      setLoadingButton(false);
      handleClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Se ha producido un error al tratar de enviar la solicitud', { variant: 'error' });
      setLoadingButton(false);
    }
  };

  const deleteItem = async (idItem) => {
    console.log('Deleted: ', idItem);
    try {
      await firestore.collection('fiscal_direction').doc(idItem).delete();
    } catch (error) {
      console.error(error);
    }
  };

  // ------------------ SelectCreate component --------------------------------------------------

  const showedProps = [
    { key: 'name', label: 'Nombre' },
    { key: 'rfc', label: 'RFC' }
  ];

  const functionListSelectCreateItem = [
    { id: 'delete', label: 'Eliminar', action: deleteItem, icon: <Icon icon="eva:trash-2-outline" /> }
  ];

  // ------------ el selectCreateId debe ser igual para el carditem y el componente SelectCreate
  const listItems = (
    <>
      {fiscalDirections.map((item) => (
        <CardItem
          key={item.id}
          selectCreateId="facturar"
          dataItem={item}
          showedProps={showedProps}
          functionList={functionListSelectCreateItem}
        />
      ))}
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Facturar</DialogTitle>
      <DialogContent>
        <SelectCreate
          selectCreateId="facturar"
          showedProps={showedProps}
          createComponent={<FormDatosCliente selectCreateId="facturar" handleClose={handleClose} />}
          listItems={listItems}
        />
        <LoadingButton
          onClick={pedirFactura}
          loading={loadingButton}
          sx={{ marginTop: '10px' }}
          fullWidth
          variant="contained"
        >
          Solicitar factura
        </LoadingButton>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
